import { Typography } from '@material-ui/core'
import { ArticleAttributes } from 'components/facets/ArticleAttributes'
import { ConditionBadge } from 'components/facets/ConditionBadge'
import { LanguageFlag } from 'components/facets/LanguageFlag'
import { AggregatedInventoryArticle, CardLanguage, flagCode } from 'shared'

interface DiffAttributesDivProps {
  id: string
  row: AggregatedInventoryArticle
  iconHeight: string
}

export const DiffAttributesDiv = ({ id, row, iconHeight }: DiffAttributesDivProps): JSX.Element => {
  return (
    <>
      <div className="d-flex flex-row align-items-center justify-content-start">
        <div data-testid={`${id}_quantity`} className={'mx-2'}>
          <Typography variant="h6">
            <b>{row.quantity}x</b>
          </Typography>
        </div>

        <div className={'mx-2'}>
          <LanguageFlag
            height={iconHeight}
            code={flagCode(row.idLanguage) || 'gg'}
            data-testid={`${id}_${CardLanguage[row.idLanguage]}-flag`}
          />
        </div>

        <div data-testid={`${id}_condition`} className={'mx-2'}>
          <ConditionBadge condition={row.condition} />
        </div>
        <div>
          <ArticleAttributes
            article={row}
            iconHeight={18}
            identifierForDataTestId={id + '-'}
            onlyExtraAttributes={true}
          />
        </div>
      </div>
    </>
  )
}
